__turbopack_context__.v({
  "className": "geist_27fcb818-module__K11dZq__className",
  "variable": "geist_27fcb818-module__K11dZq__variable",
});
